import { render, staticRenderFns } from "./ModelManage.vue?vue&type=template&id=3ee32482&"
import script from "./ModelManage.vue?vue&type=script&lang=js&"
export * from "./ModelManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports